import React from "react";

const GlobalLoader = () => {
  return <div className="loader"></div>;
};

export default GlobalLoader;
